"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ENUMS = exports.classes = exports.LunaModalSizes = exports.LunaModalTypes = void 0;

var _types, _sizes;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LunaModalTypes = {
  "default": 'default',
  wide80: 'wide80',
  tall80: 'tall80'
};
exports.LunaModalTypes = LunaModalTypes;
var LunaModalSizes = {
  "default": 'default',
  modal40: 'modal40',
  modal80: 'modal80',
  modal100: 'modal100'
};
exports.LunaModalSizes = LunaModalSizes;
var __baseClass = 'luna-modal';
var __overlayClass = 'luna-modal--overlay';
var __openClass = 'luna-modal-is_open';
var __bodyOpenClass = 'luna-modal--body-is_open';
var classes = {
  base: __baseClass,
  overlay: __overlayClass,
  open: __openClass,
  bodyOpen: __bodyOpenClass,
  types: (_types = {}, _defineProperty(_types, LunaModalTypes["default"], ""), _defineProperty(_types, LunaModalTypes.wide80, "luna-modal-80-wide"), _defineProperty(_types, LunaModalTypes.tall80, "luna-modal-80-tall"), _types),
  sizes: (_sizes = {}, _defineProperty(_sizes, LunaModalSizes["default"], "luna-modal-40"), _defineProperty(_sizes, LunaModalSizes.modal40, "luna-modal-40"), _defineProperty(_sizes, LunaModalSizes.modal80, "luna-modal-80"), _defineProperty(_sizes, LunaModalSizes.modal100, "luna-modal-100"), _sizes)
};
exports.classes = classes;
var ENUMS = {
  LunaModalTypes: LunaModalTypes,
  LunaModalSizes: LunaModalSizes
};
exports.ENUMS = ENUMS;
